import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Loader } from '../../common'
import LaundryRulesTable from '../../containers/LaundryRulesTable'
import LaundryTimesTable from '../../containers/LaundryTimesTable'
import LaundryTable from '../../containers/LaundryTable'
import NewLaundryTimeModal from '../../containers/NewLaundryTimeModal'
import EditLaundryTimeModal from '../../containers/EditLaundryTimeModal'
import NewLaundryModal from '../../containers/NewLaundryModal'
import EditLaundryModal from '../../containers/EditLaundryModal'
import EditLaundryTypeModal from '../../containers/EditLaundryTypeModal'
import EditBookingRangeModal from '../../containers/EditBookingRangeModal'
import EditMaxBookingsModal from '../../containers/EditMaxBookingsModal'

import * as dataActions from '../../actions/Data'

class LaundrySettings extends React.Component {
  componentDidMount() {
    const { data } = this.props

    this.fetch()
  }

  fetch() {
    const { user, data } = this.props

    if (!data.laundrySystem) {
      this.props.tryGetLaundrySystem(user.token, data.community.id)
    }
  }

  render() {
    const { classes, data } = this.props

    if (!data.laundrySystem) {
      return (
        <main className={classes.content}>
          <Loader />
        </main>
      )
    }

    return (
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <LaundryRulesTable />
        <div className={classes.appBarSpacer} />
        <LaundryTimesTable />
        <div className={classes.appBarSpacer} />
        <LaundryTable />
        <NewLaundryTimeModal />
        <EditLaundryTimeModal />
        <NewLaundryModal />
        <EditLaundryModal />
        <EditLaundryTypeModal />
        <EditBookingRangeModal />
        <EditMaxBookingsModal />
      </main>
    )
  }
}

const Styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: '100vh',
    overflow: 'auto'
  }
})

LaundrySettings.propTypes = {
  classes: PropTypes.object.isRequired
}

function mapStateToProps({ data, user }) {
  return { data, user }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...dataActions }, dispatch)
}

export default compose(
  withStyles(Styles),
  connect(mapStateToProps, mapDispatchToProps)
)(LaundrySettings)



// WEBPACK FOOTER //
// ./src/components/pages/LaundrySettings/index.js